<template>
  <div class="bg">
    <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
      <div class="button">
        <i @click="showSearch = true" class="iconfont icon-chaxun"></i>
        <i class="iconfont icon-gengduo1" @click="showDialog = true" />
        <van-popup
          v-model="showSearch"
          round
          position="bottom"
          :style="{ height: 'auto' }"
          closeable
        >
          <van-field
            v-model="name"
            clearable
            label="姓名"
            placeholder="请输入要查询的人员姓名"
          />
          <van-field
            v-model="idCardNumber"
            clearable
            label="证件号码"
            placeholder="请输入要查询的人员证件号码"
          />
          <div class="searchBtn">
            <span style="font-size: 14px; color: #576b95" @click="itemList">
              查询人员
            </span>
          </div>
          <van-picker
            show-toolbar
            cancel-button-text=" "
            confirm-button-text="查询人员"
            toolbar-position="bottom"
            @confirm="searchTeam"
            :columns="teamOptions"
          />
        </van-popup>
        <van-dialog
          v-model="showDialog"
          title="批量操作"
          show-cancel-button
          :show-confirm-button="false"
          :before-close="closeDialog"
          :close-on-click-overlay="true"
        >
          <el-button type="danger" size="small" @click="selectDelete">
            批量删除
          </el-button>
          <el-button type="danger" size="small" @click="selectExit"> 批量退场 </el-button>
          <el-button type="success" size="small" @click="selectEnter">
            批量进场
          </el-button>
          <el-button type="primary" size="small" @click="showIssue"> 下发名单 </el-button>
          <el-button type="primary" size="small" @click="showTeam">更换班组</el-button>
        </van-dialog>
        <van-popup
          v-model="showIssuePopup"
          round
          position="bottom"
          :style="{ height: 'auto' }"
          closeable
        >
          <van-field
            v-model="workersName"
            rows="2"
            autosize
            label="人员名单："
            type="textarea"
            readonly
            maxlength="200"
          />
          <span v-if="workersName.length == 200">(名单溢出部分已隐藏)</span>
          <div class="checkBox">
            <span>考勤设备：</span>
            <van-checkbox-group v-model="result" ref="checkboxGroup">
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in equipmentOptions"
                  clickable
                  :key="index"
                  :title="`${item.show}`"
                  @click="toggle(index, item.id)"
                >
                  <template #right-icon>
                    <van-checkbox :name="item" ref="checkboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div class="operateBtn">
            <el-button type="primary" size="mini" @click="distributionTemplate">
              提交名单
            </el-button>
          </div>
        </van-popup>
        <van-popup
          v-model="showTeamPopup"
          round
          position="bottom"
          :style="{ height: 'auto' }"
          closeable
        >
          <van-field
            v-model="workersName"
            rows="2"
            autosize
            label="人员名单："
            type="textarea"
            readonly
            maxlength="200"
          />
          <span v-if="workersName.length == 200">(名单溢出部分已隐藏)</span>
          <div class="checkBox">
            <van-picker
              show-toolbar
              confirm-button-text="提交名单"
              toolbar-position="bottom"
              @confirm="submitTeam"
              :columns="teamOptions"
            />
          </div>
          <div class="operateBtn"></div>
        </van-popup>
      </div>
      <div v-show="showPagination !== 0">
        <div>
          <el-checkbox
            v-model="checkedAll"
            :indeterminate="isIndeterminate"
            @change="checkAll"
          >
            全选
          </el-checkbox>
        </div>
        <el-checkbox-group v-model="checkedOne" @change="checkOne">
          <div class="content">
            <van-swipe-cell
              v-for="(item, index) in itemInfo"
              :key="index"
              :before-close="beforeClose"
            >
              <el-card>
                <!-- v-model绑定的数组的值要与这里的label绑定的指要一致 -->
                <el-checkbox :label="item">
                  <div @click="goDetail(item.id)">
                    <el-row>
                      <el-col :span="24">
                        <span>工人编号：{{ item.jobNo }}</span>
                      </el-col>
                      <el-col :span="24">
                        <span>工人姓名：{{ item.name }}</span>
                      </el-col>
                      <el-col :span="24">
                        <span>所属项目：{{ project }}</span>
                      </el-col>
                      <el-col :span="24">
                        <span>所属单位：{{ item.unitId }}</span>
                      </el-col>
                      <el-col :span="24">
                        <!-- v-if="item.team == !''" -->
                        <span>所属班组：{{ item.teamId }}</span>
                        <!-- <span v-else>所属班组：暂无信息</span> -->
                      </el-col>

                      <el-col :span="24">
                        <span>证件号码：{{ item.idCardNumber }}</span>
                      </el-col>
                      <el-col v-if="item.payRollBankCardNumber !== ''" :span="24">
                        <span>银行卡号：{{ item.payRollBankCardNumber }}</span>
                      </el-col>
                      <el-col v-else :span="24">
                        <span>银行卡号：暂无银行卡信息</span>
                      </el-col>
                      <el-col :span="24">
                        <span>签订合同：{{ item.isContract }}</span>
                      </el-col>
                      <el-col v-if="item.nonAttendanceDays == '暂无考勤记录'" :span="24">
                        <span>未考勤天数：{{ item.nonAttendanceDays }}</span>
                      </el-col>
                      <el-col v-else :span="24">
                        <span>未考勤天数：{{ item.nonAttendanceDays }}天</span>
                      </el-col>
                      <el-col v-if="item.qualified=='1'">
                        <span>头像标准：合格</span>
                      </el-col>
                      <el-col v-else>
                        <span>头像标准：不合格</span>
                      </el-col>
                      <el-col :span="24">
                        <el-tag v-if="item.status == '在场'" type="success" size="small">
                          <span>进场状态：{{ item.status }}</span>
                        </el-tag>
                        <el-tag v-else type="danger" size="small">
                          <span>进场状态：{{ item.status }}</span>
                        </el-tag>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="btn">
                    <p>
                      <el-button type="primary" size="mini" @click="goBank(item.id)">
                        银行账号
                      </el-button>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="goContract(item.id, item.hasContract, item.status)"
                      >
                        签订合同
                      </el-button>
                      <el-button type="primary" size="mini" @click="goDetail(item.id)">
                        详情
                      </el-button>
                      <el-button type="primary" size="mini" @click="goEdit(item.id)">
                        修改
                      </el-button>
                    </p>
                    <p>
                      <el-button
                        v-if="item.status == '在场'"
                        type="danger"
                        size="mini"
                        @click="goExit(item.id)"
                      >
                        退场
                      </el-button>

                      <el-button
                        v-else
                        @click="goEnter(item.id)"
                        type="success"
                        size="mini"
                      >
                        进场
                      </el-button>
                      <el-button size="mini" type="danger" @click="deleteItem(item.id)">
                        删除
                      </el-button>
                    </p>
                  </div>
                </el-checkbox>
              </el-card>

              <template #right>
                <van-button square type="danger" text="删除" />
              </template>
            </van-swipe-cell>
          </div>
        </el-checkbox-group>
        <el-pagination
          :current-page.sync="page.currentPage"
          :page-sizes="page.pageSizes"
          :page-size="page.pageSize"
          :total="page.totalCount"
          layout="sizes ,pager, next "
          :on-load="itemList"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
      <el-card v-show="showPagination == 0" body-style="text-align:center">
        <span>暂无数据</span>
      </el-card>
      <div style="margin-top: 10px; text-align: right">
        <el-button
          v-show="showPagination == 0"
          size="mini"
          type="primary"
          @click="goBack"
        >
          返回
        </el-button>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Toast } from "vant";
import { filtration$ } from "@/utils/admin";
import { postListUnit } from "@/api/app/unit";
import { postProjectId } from "@/api/app/project";
import { postListTeam, postTeamDetail } from "@/api/app/team";
import { PostListEquipmentByProjectId } from "@/api/app/equipment";
import {
  postListPage,
  postRemove,
  postEntryOrExit,
  postDistributionTemplate,
} from "@/api/app/roster";
let ids = [];
export default {
  data() {
    return {
      name: "",
      idCardNumber: "",
      // 所属项目
      project: "",
      unit: "",
      // 考勤设备列表
      result: [],
      equipmentOptions: [],
      // 全选
      checkedAll: false,
      checkedOne: [],
      isIndeterminate: false,
      // 批量操作
      showDialog: false,
      showIssuePopup: false,
      showSearch: false,
      // 分页
      page: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      // 更换班组
      showTeamPopup: false,
      teamOptions: [{ text: "", children: [{ text: "" }] }],
      itemInfo: {},
      query: {},
      workersName: "",
      isLoading: false,
      // 退场时间
      showTimePopup: false,
      minDate: new Date(new Date().getFullYear() - 2, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 2, 1, 1),
      currentDate: new Date(),
      showPagination: Number,
    };
  },
  computed: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex() {
      return this.$store.state.app.projectId;
    },
  },
  watch: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex(e) {
      if (e !== this.projectId) {
        // 获取项目信息
        this.itemList();
        // 刷新当前页面
        // location.reload();
        this.listEquipmentByProjectId();
      }
    },
  },
  created() {
    this.$store.dispatch("submitToken");
    this.itemList();
    this.listEquipmentByProjectId();
  },
  mounted() {
    this.itemList();
  },
  methods: {
    // 获取列表信息
    itemList(value, page, params = {}) {
      // 根据vuex的寸的projectId获取所属项目名称
      postProjectId(this.$store.state.app.projectId).then((res) => {
        this.project = res.data.name;
      });
      this.query.projectId = this.$store.state.app.projectId;
      this.query.status = this.$route.query.status;
      // this.query.endTime = this.$route.query.endTime;
      if (this.name !== "") {
        this.query.name = this.name;
      }
      if (this.idCardNumber !== "") {
        this.query.idCardNumber = this.idCardNumber;
      }
      postListPage(
        this.page.currentPage,
        this.page.pageSize,
        Object.assign(params, this.query)
      ).then((listPage) => {
        let team = [];
        this.showSearch = false;
        this.page = listPage.data;
        this.showPagination = listPage.data.result.length;
        postListTeam(listPage.data.result[0].unitId).then((res) => {
          team = res.data;
        });
        // 所属单位
        postListUnit(this.$store.state.app.projectId).then((unit) => {
          listPage.data.result.forEach((id) => {
            // 所属企业
            unit.data.find((item) => {
              if (id.unitId == item.id) {
                id.unitId = item.title;
              }
            });
            // 所属班组
            team.find((item) => {
              if (id.teamId == item.id) {
                id.teamId = item.title;
              }
            });
            // 银行卡号
            if (id.payRollBankCardNumber == undefined || id.payRollBankCardNumber == "") {
              id.payRollBankCardNumber = "暂无银行卡信息";
            }
            // 未考勤天数
            if (id.nonAttendanceDays == undefined) {
              id.nonAttendanceDays = "暂无考勤记录";
            }
            // 状态
            this.$store.state.app.dict.find((e) => {
              if (e.value == id.status) {
                id.status = e.label;
              }
            });
            // 签订合同
            if (id.hasContract == 1 ) {
              id["isContract"] = "已签订";
            } else if (id.hasContract == 2 || id.hasContract==undefined) {
              id["isContract"] = "未签订";
            }
          }); // 单位选择器
          this.teamOptions = unit.data.map((item) => {
            return { text: item.title, unitId: item.id, ...item };
          });
          this.teamOptions.forEach((item) => {
            item.children = team.map((items) => {
              return { text: items.title, value: item.id, ...items };
            });
          });
          this.itemInfo = listPage.data.result;
        });
      });
    },
    // 考情设备列表
    listEquipmentByProjectId() {
      PostListEquipmentByProjectId(this.$store.state.app.projectId).then((res) => {
        this.equipmentOptions = res.data.map((item) => {
          return { show: item.sn + "｜" + item.name, ...item };
        });
        this.result = this.equipmentOptions;
      });
    },
    // 人员下发
    showIssue() {
      if (ids.length == 0) {
        this.$notify({ type: "warning", message: "至少选择一条数据才能继续操作！" });
        this.showDialog = false;
      } else {
        this.showDialog = false;
        this.showIssuePopup = true;
      }
    },
    // 考勤设备选择
    toggle(index, id) {
      this.$refs.checkboxes[index].toggle();
    },
    // 提交下发设备名单
    distributionTemplate() {
      let form = {
        ids: ids,
        projectId: this.$store.state.app.projectId,
        sns: this.result.map((item) => {
          return item.sn;
        }),
      };
      //批量下发默认为手动下发
      form.type = 2;

      postDistributionTemplate(form).then((res) => {
        if (res.code == 200) {
          this.$notify({ type: "success", message: "提交成功！" });
          this.showIssuePopup = false;
        }
      });
    },
    // 提交更换班组名单
    submitTeam(value) {
      let form = {
        ids: ids,
        status: 2,
        projectId: this.$store.state.app.projectId,
      };
      // 单位
      this.teamOptions.forEach((item) => {
        if (value[0] == item.title) {
          form.unitId = item.id;
        }
      });
      // 班组
      this.teamOptions.forEach((item) => {
        item.children.forEach((items) => {
          if (value[1] == items.title) {
            form.teamId = items.id;
          }
        });
      });
      postEntryOrExit(form).then((res) => {
        if (res.code == 200) {
          this.$notify({ type: "success", message: "提交成功！" });
          this.showTeamPopup = false;
          this.itemList();
        }
      });
    },
    searchTeam(value) {
      delete this.query.status;
      // 单位
      this.teamOptions.forEach((item) => {
        if (value[0] == item.title) {
          this.query.unitId = item.id;
        }
      });
      // 班组
      this.teamOptions.forEach((item) => {
        item.children.forEach((items) => {
          if (value[1] == items.title) {
            this.query.teamId = items.id;
          }
        });
      });
      this.itemList();
    },
    // 返回
    goBack() {
      if (this.name !== "" || this.idCardNumber !== "") {
        location.reload();
      } else {
        this.$router.back();
      }
    },
    // 更换班组
    showTeam() {
      if (ids.length == 0) {
        this.showDialog = false;
        this.$notify({ type: "warning", message: "至少选择一条数据才能继续操作！" });
      } else {
        this.showTeamPopup = true;
        this.showDialog = false;
      }
    },
    // 删除单个列表
    deleteItem(ids) {
      this.$dialog
        .confirm({
          message: "确定删除吗？",
        })
        .then(() => {
          postRemove([ids]).then((res) => {
            this.$notify({ type: "success", message: "删除成功！" });
            this.itemList();
          });
        });
    },
    // 删除选中列表
    selectDelete() {
      if (ids.length == 0) {
        this.showDialog = false;
        this.$notify({ type: "warning", message: "至少选择一条数据才能继续操作！" });
      } else {
        this.$dialog
          .confirm({
            message: "确定批量删除吗？",
          })
          .then(() => {
            postRemove(ids).then((res) => {
              this.$notify({ type: "success", message: "删除成功！" });
              this.itemList();
            });
            this.showDialog = false;
          });
      }
    },
    // 左滑删除人员
    beforeClose({ position, instance, name }) {
      switch (position) {
        case "right":
          this.$dialog
            .confirm({
              message: "确定删除吗？",
            })
            .then(() => {
              postRemove([name]).then((res) => {
                this.$notify({ type: "success", message: "删除成功！" });
                this.itemList();
              });
              instance.close();
            });
          break;
      }
    },
    // 刷新
    onRefresh() {
      this.itemList();
      Toast("刷新成功");
      this.isLoading = false;
    },
    // 批量操作弹窗关闭
    closeDialog(action, done) {
      done();
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.itemList(this.page);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.itemList(this.page);
    },
    // el-card全选
    checkAll(val) {
      this.checkedOne = val ? this.itemInfo : [];
      this.isIndeterminate = false;
      if (val == true) {
        ids = this.itemInfo.map((item) => {
          return item.id;
        });
      } else {
        ids = [];
      }
      this.workersName = this.itemInfo.map((item) => {
        return item.name;
      });
    },
    // el-card选中单个
    checkOne(value) {
      let checkedCount = value.length;
      this.checkedAll = checkedCount === this.itemInfo.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.itemInfo.length;
      ids = value.map((item) => {
        return item.id;
      });
      this.workersName = value.map((item) => {
        return item.name;
      });
    },
    // 跳转到银行卡信息
    goBank(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: "/recruit/editBankNum" });
    },
    // 跳转到签订合同页面
    goContract(id, hasContract, status) {
      if ((hasContract === 2 && status == "在场") || hasContract==undefined) {
        this.$store.commit("ItemId", id);
        this.$router.push({ path: "/recruit/contract" });
      } else if (status == "退场") {
        this.$notify({ type: "warning", message: "该人员未进场，无法签订合同" });
      } else if (hasContract === 1) {
        this.$notify({ type: "warning", message: "该人员已签订合同" });
      }
    },
    // 跳转到参详情
    goDetail(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: "/recruit/detailedInfo" });
    },
    // 跳转到办理进场
    goEnter(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: `/recruit/enter/${1}` });
    },
    // 跳转到批量进场
    selectEnter() {
      if (ids.length == 0) {
        this.showDialog = false;
        this.$notify({ type: "warning", message: "至少选择一条数据才能继续操作！" });
      } else {
        this.$store.commit("Content", this.workersName);
        this.$store.commit("ItemId", ids);
        this.$router.push({ path: `/recruit/enter/${2}` });
      }
    },
    // 跳转到办理退场
    goExit(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: `/recruit/exit/${1}` });
    },
    // 跳转到批量退场
    selectExit() {
      if (ids.length == 0) {
        this.showDialog = false;
        this.$notify({ type: "warning", message: "至少选择一条数据才能继续操作！" });
      } else {
        this.$store.commit("Content", this.workersName);
        this.$store.commit("ItemId", ids);
        this.$router.push({ path: `/recruit/exit/${2}` });
      }
    },
    // 跳转到编辑页面
    goEdit(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: `/recruit/essentialInfo/${1}` });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  padding: 10px;
  min-height: 100vh;
  margin-bottom: 60px;
  background-color: #f0f0f0;
}
.el-button + .el-button {
  margin-left: 0;
}
.button {
  width: 100%;
  // display: flex;
  margin-bottom: 10px;
  text-align: right;
  i {
    font-size: 24px;
    color: #606266;
    margin: 0 2px 0 2px;
  }
  .van-field:nth-child(1) {
    margin-top: 45px;
  }
  .search {
    width: 100%;
    height: 28px;
    padding-left: 5px;
    border-bottom: 1px solid #e4e7ed;
    i {
      font-size: 17px;
      color: #909399;
      margin-right: 10px;
    }
    span {
      font-size: 14px;
      color: #909399;
    }
  }

  .searchBtn {
    margin: 10px 15px 50px 0;
    text-align: right;
  }
}
/deep/ .van-dialog__content {
  width: 100%;
  display: flex;
  padding: 10px;
  flex-wrap: wrap;
}
.el-button--small {
  margin-bottom: 5px;
}
.el-checkbox {
  margin-bottom: 5px;
}
/deep/ .el-checkbox__inner {
  width: 19px;
  height: 19px;
  border-radius: 50%;
}
/deep/ .el-checkbox__inner::after {
  top: 3px;
  left: 7px;
}
/deep/ .van-cell__value {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
// 批量下发弹窗
.van-popup {
  padding-bottom: 20px;
  /deep/ span {
    font-size: 15px;
  }
  .checkBox {
    // width: 100%;
    padding: 10px 20px 20px 20px;
    span {
      font-size: 15px;
      display: block;
      margin-bottom: 10px;
    }
    span:first-child {
      color: #646566;
      text-align: left;
    }
    /deep/ .van-cell {
      padding: 10px 40px 10px 0;
    }
  }
  .operateBtn {
    text-align: right;
    margin: 0 20px 10px 0;
  }
}
.content {
  .van-button {
    height: 100%;
  }
  .el-card {
    margin-bottom: 10px;
    /deep/ .el-card__body {
      padding: 15px;
    }
    .img {
      img {
        width: 130px;
        height: 130px;
        border-radius: 4px;
      }
    }
    div {
      margin-bottom: 5px;
      font-size: 14px;
    }
    p {
      margin-bottom: 8px;
    }
    span {
      font-size: 14px;
    }
    /deep/ .el-checkbox__input {
      position: absolute !important;
      left: -10px;
    }
    .btn {
      margin-top: 10px;
      width: 100%;
      text-align: right;
      position: relative;
    }
  }
}
// 分页
/deep/ .el-pagination {
  padding: 0;
  overflow: hidden;
}
/deep/ .el-pagination .el-select .el-input {
  margin: 0;
}
</style>
